import React, { useState } from 'react';
import HabboImage from './HabboImage';
import { getHabboImageUrl } from './HabboImage';
import { getAvatarBgStyle } from '../services/profileColorService';

export function FurniIcon({ code, size = 40 }) {
    const [fb, setFb] = useState(false);
    const [err, setErr] = useState(false);
    const c = String(code || '').replace(/%2a/gi, '*');
    const star = c.indexOf('*');
    const base = star === -1 ? c : c.slice(0, star);
    const rest = star === -1 ? '' : c.slice(star);
    const primary = `https://furni.franklyorigins.net/api/furniture/render?furni=${encodeURIComponent(`${base}_small${rest}`)}&direction=0&state=1&frame=0&width=120&height=120`;
    const fallback = `https://furni.franklyorigins.net/api/furniture/render?furni=${encodeURIComponent(c)}&direction=0&state=0&frame=0&width=120&height=120`;
    return (
        <div className="flex items-center justify-center bg-gray-100 overflow-hidden" style={{ width: size, height: size }}>
            {err ? <span className="text-base font-['Jersey_10'] text-black/30">?</span> : (
                <img src={fb ? fallback : primary} alt="" onError={() => !fb ? setFb(true) : setErr(true)}
                     style={{ imageRendering: 'pixelated', width: '100%', height: '100%', objectFit: 'contain' }} />
            )}
        </div>
    );
}

export function WinnerImage({ seg }) {
    if (!seg) return null;
    if (seg.type === 'habbo') {
        const bgStyle = getAvatarBgStyle(seg.isMember ? seg.bgColor : '#F2F2F2');
        const imgSrc = getHabboImageUrl({
            habbo: seg.habboName,
            size: 's',
            direction: 2,
            head_direction: 2,
            shadow: false
        });

        return (
            <div className="flex items-center justify-center my-2">
                <div
                    style={{
                        width: '20vmin',
                        height: '20vmin',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '0.6vmin solid rgba(0,0,0,0.12)',
                        flexShrink: 0,
                        ...bgStyle,
                    }}
                >
                    <img
                        src={imgSrc}
                        alt={seg.habboName}
                        style={{ imageRendering: 'pixelated', transform: 'scale(2)' }}
                    />
                </div>
            </div>
        );
    }
    if (seg.type === 'furni' && seg.furnis?.length) {
        return (
            <div className="flex gap-2 items-end justify-center flex-wrap my-2">
                {seg.furnis.slice(0, 4).map(f => (
                    <div key={f.code} className="flex flex-col items-center gap-0.5">
                        <FurniIcon code={f.code} size={80} />
                        <span className="font-['Jersey_10'] text-lg text-coal/60 leading-none">x{f.qty ?? 1}</span>
                    </div>
                ))}
            </div>
        );
    }
    if (seg.type === 'custom' && seg.iconNum) {
        return (
            <div className="flex items-center justify-center my-2">
                <img src={`${process.env.PUBLIC_URL}/img/icons/icon_${seg.iconNum}.png`} alt=""
                     style={{ width: 72, height: 72, objectFit: 'contain' }} />
            </div>
        );
    }
    return null;
}